// File: PartnershipAnnualCompliance.jsx
import React from "react";

export default function PartnershipAnnualCompliance() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Partnership Firm Compliance
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks manages partnership compliance and tax obligations.
          </p>
          <p className="text-gray-700">
            Complete annual compliance services for partnership firms including ITR-5 filing, financial statements, partner KYC, statutory records, GST returns, and Income Tax compliance under Partnership Act 1932.
          </p>
        </div>

        {/* Right: Image (PARTNERSHIP COMPLIANCE SPECIFIC) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Partnership firm annual compliance services by Hawkins & Brooks"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless partnership compliance.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Partnership deed and amendments</li>
                <li>Financial statements (Balance Sheet, P&L)</li>
                <li>PAN and partner KYC documents</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Reliable compliance management ensuring complete partnership firm regulatory obligations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Partnership Act Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of Indian Partnership Act 1932 requirements including partnership deed registration, partner changes, profit-sharing ratios, dissolution procedures, statutory records, and compliance with Income Tax & GST laws.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Tax & ITR Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise ITR-5 e-filings, Form 26AS reconciliation, partner capital account statements, audit reports (if turnover > ₹1 Cr), advance tax calculations, TDS compliance, and penalty avoidance through accurate tax computations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service partnership compliance from financial statement preparation through ITR filings, GST returns, partner KYC updates, statutory register maintenance, compliance audits, and ongoing advisory for firm changes and regulatory updates.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
